import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
/**
 * The `<video>` a {@link useQrCamera} stream plays into.
 *
 * One element for every scanner because its attributes are the part that is easy to get wrong and
 * silent when it is: without `playsInline` iOS Safari takes the stream full-screen, without `muted`
 * an engine may refuse to autoplay it, and it is `aria-hidden` because a moving picture of a QR
 * code says nothing to a screen reader — every scanner's controls and status line do.
 *
 * Where it sits, how big it is and what is drawn over it are the caller's: the member scanner and
 * the check-in screen draw different frames around the same picture.
 */
export const QrCameraVideo = React.forwardRef(function QrCameraVideo({ className }, ref) {
    return _jsx("video", { ref: ref, playsInline: true, muted: true, autoPlay: true, "aria-hidden": true, className: className });
});
//# sourceMappingURL=qr-camera-video.js.map